<template>
    <div>
        <div class="flex flex-row w-full">
            <ev-datepicker :model-value="localValue.start" @update:model-value="updateStart"/>
            <div class="text-2xl"> ~ </div>
            <ev-datepicker :model-value="localValue.end" @update:model-value="updateEnd"/>
        </div>
        <ev-radio-group class="mt-2" v-if="selectGroup" name="groups"
            :model-value="selectedGroup" @update:model-value="changeDate" :options="[
            {label:'오늘', value:1},
            {label:'일주일', value:7},
            {label:'15일', value:15},
            {label:'한달', value:30},
            {label:'두달', value:60},
            {label:'1년', value:365},
        ]"></ev-radio-group>
    </div>
</template>

<script>
    import EvDatepicker from "./EvDatepicker";
    import moment from "moment";
    export default {
        name: "EvDateRange",
        components: {EvDatepicker},
        emits: ['input', 'update:modelValue', 'update:value'],
        props:{
            beforeDays : {
                default : 30
            },
            selectGroup : {
                type:Boolean,
                default : false
            },
            value: { default: undefined },
            modelValue: { default: undefined }
        },
        watch:{
            resolvedValue(obj){
                if(!obj){
                    return;
                }
                this.localValue = { ...obj };
            }
        },
        computed: {
            resolvedValue() {
                return typeof this.modelValue !== 'undefined' ? this.modelValue : this.value;
            }
        },
        methods: {
            emitValue(value) {
                this.$emit('update:modelValue', value);
                this.$emit('update:value', value);
                this.$emit('input', value);
            },
            updateStart(val) {
                this.localValue.start = val;
                this.emitValue({ ...this.localValue });
            },
            updateEnd(val) {
                this.localValue.end = val;
                this.emitValue({ ...this.localValue });
            },
            changeDate(val) {
                this.selectedGroup = val;
                let value = (new moment()).subtract(parseInt(val), 'days').format("YYYY-MM-DD");
                this.updateStart(value);
            }
        },
        data() {
            return {
                localValue : {
                    start: '',
                    end : ''
                },
                selectedGroup: null
            }
        },
        mounted() {
            if(this.resolvedValue){
                this.localValue = { ...this.resolvedValue };
            }
        }
    }
</script>

<style scoped>

</style>
